import t from "./index795.js";
function e() {
  if (!arguments.length)
    return [];
  var r = arguments[0];
  return t(r) ? r : [r];
}
export {
  e as default
};
